import {
  ETextParamType_LocationHref,
  ETextParamType_RoomID,
  ETextParamType_ShowWorldSelect,
  ETextParamType_SpotName,
  ETextParamType_WorldID
} from './const';
import {getSkyRoomId, getSpotId, getWorldId, getWorldSelectedToggle} from './dataOps';
import {hel_setText} from './moduleCaller';

/**
 * @remarks
 * boot前に下記の諸情報をHeliodorに設定
 * - WorldId
 * - RoomId
 * - SpotName
 * - Location
 * - SelectedWorld
 */
export const presetBeforeBoot = () => {
  const worldId = getWorldId();
  const skyRoomId = getSkyRoomId();
  const spotId = getSpotId();
  if (worldId !== undefined) {
    hel_setText(ETextParamType_WorldID, worldId);
  }
  if (skyRoomId !== undefined) {
    hel_setText(ETextParamType_RoomID, skyRoomId);
  }
  if (spotId !== undefined) {
    hel_setText(ETextParamType_SpotName, spotId);
  }
  hel_setText(ETextParamType_LocationHref, window.location.href);
  hel_setText(ETextParamType_ShowWorldSelect, getWorldSelectedToggle() ? '1' : '0');
};
